const {h, render, Component} = require('preact');
const {route} = require('preact-router');

const Articles = require('./all_articles')
const TrendingTopics = require('./trending_topics')
const SpinnerView = require('../../views/common/spinner')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')

class FAQMain extends Component {
  constructor(props) {
    super(props);
    this.getContentId = this.getContentId.bind(this)
  }


  getContentId(){
    return window.location.hash.split('-')[1].split('?')[0]
  }

  componentWillMount() {
    let hash = window.location.hash
    if (hash && hash.length > 0) {
      hash = hash.slice(1)
      this.setState({hashValue: null, isSearching: true, 'isLoading': true})
      let hashValueUrl = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/url_friendly_hashes?urlFriendlyHashes=${hash}`;
      let errorCb = () => {
        this.setState({'isFailure': true});
      }
      let successCb = (response) => {
        if (response) {
          this.setState({hashValue: response, isSearching: false, 'isLoading': false});
        }
      }
      this.setState({'isLoading': true})
      SupportAPIHelper.get(hashValueUrl, null, successCb, errorCb, false);
    }
  }

  getUrlFriendlyHashesValue() {
    let hashValue = this.state.hashValue
    if (hashValue) {
      hashValue = hashValue.urlHashValue
      let idObj = null
      if (hashValue) {
        if (hashValue.TYPE == 'Content') {
          idObj = {'contentId': hashValue.ID}
        }
        if (hashValue.TYPE == 'Category') {
          idObj = {'categoryId': hashValue.ID}
        }
        if (idObj)
          return <Articles guestOrder={this.props.guestOrder} onGuestHelp={this.props.onGuestHelp} showGuestHelp={this.props.showGuestHelp} pageParams={idObj} fromFaq={false} crumbs={this.props.crumbs}/>
        else
          route("/faq")
      }
    }

  }

  getFAQPage()
  {
    let hash = window.location.hash
    let redirectFAQUrls = Groupon.Utils.getConfigFromDom().redirectFAQUrls
    if(redirectFAQUrls && redirectFAQUrls[hash]) 
      window.location.hash = hash = redirectFAQUrls[hash]
    if(hash)
    {
      if(hash.match(/faqs:category-\d+/g))
        return <Articles guestOrder={this.props.guestOrder} onGuestHelp={this.props.onGuestHelp} showGuestHelp={this.props.showGuestHelp} pageParams={{'categoryId': this.getContentId()}} fromFaq={true} crumbs={this.props.crumbs}/>
      if(hash.match(/faqs:content-\d+/g))
        return <Articles guestOrder={this.props.guestOrder} onGuestHelp={this.props.onGuestHelp} showGuestHelp={this.props.showGuestHelp} pageParams={{'contentId': this.getContentId()}} fromFaq={true} crumbs={this.props.crumbs}/>
      return this.getUrlFriendlyHashesValue()
    }
    return <TrendingTopics crumbs={this.props.crumbs}/>
  }
  render() {
    if(this.state.isLoading)
      return (<SpinnerView/>)
    return (
      <div>
        {this.getFAQPage()}
      </div>
    )
  }
}

module.exports = FAQMain
